import API from './api'
import CMSAPI from './cmsApi'
import myServer from '../request/request.js'
myServer.parseRouter('farms', API)
myServer.parseRouter('cms', CMSAPI)
export default myServer
